<template>
  <v-table>
    <v-thead>
      <tr>
        <v-table-th>Nume</v-table-th>
        <v-table-th>Cod fiscal</v-table-th>
        <v-table-th>Nr inregistrare</v-table-th>
        <v-table-th>Status</v-table-th>
        <v-table-th class="text-center">Actiuni </v-table-th>
      </tr>
    </v-thead>
    <v-tbody>
      <tr v-for="row in rows" :key="row.id">
        <v-table-td>
          <p class="text-gray-900 whitespace-no-wrap">
            {{ row.name }}
          </p>
        </v-table-td>
        <v-table-td>
          {{row.fiscal_code}}
        </v-table-td>
        <v-table-td>
          {{row.registration_number}}
        </v-table-td>
        <v-table-td>
          {{ row.status.name }}
        </v-table-td>
        <v-table-td class="text-center">
          <router-link
            :to="{
              name: 'vendors.show',
              params: { id: row.id },
            }"
            class="text-sm font-medium text-blue-500 hover:text-blue-700"
          >
            Vizualizeaza
          </router-link>
        </v-table-td>
      </tr>
    </v-tbody>
  </v-table>
</template>

<script>
import VTable from "./ui/VTable.vue";
import VTableTd from "./ui/VTableTd.vue";
import VTableTh from "./ui/VTableTh.vue";
import VTbody from "./ui/VTbody.vue";
import VThead from "./ui/VThead.vue";
export default {
  components: {
    VTableTd,
    VTable,
    VThead,
    VTableTh,
    VTbody,
  },

  props: {
    rows: {
      type: Array,
    },
  },
};
</script>
